import {personalCheck} from "@/api/login/login";
import {isSupport, xda} from "@hybird/flutter";
import {Dialog, Toast} from "vant";
import service, {setSessionId, setHeader} from "@hybird/core/request";
import {config} from "@hybird/device/config";
import request, {getSourceType} from "@/utils/request";
import {Device} from "@hybird/device";
import {useDeviceStore, useEnvStore} from "@/store/home";
import {defaultError, WebError} from "@hybird/core/error";
import NoSleep from "nosleep.js";
import {uploadManager} from "@hybird/device/request";
import useSealImageUpload, {
  backgroundUploadFile,
  backgroundRequest
} from "@/views/useDevice/hooks/useSealImageUpload";

uploadManager.registerProxyFunction("uploadImageFile", async function (...arg) {
  return service.uploadFile(...arg);
});

uploadManager.registerProxyFunction("backgroundUploadFile", backgroundUploadFile);

uploadManager.registerProxyFunction("backgroundRequest", backgroundRequest);


const noSleep = new NoSleep();

function enableNoSleep() {
  noSleep
          .enable()
          .then(() => {
            console.log("防息屏开启成功");
          })
          .catch((e) => {
            console.log("防息屏开启失败", e);
          });
}

// 初始启用（需在用户交互事件中触发，如点击）
document.addEventListener("click", () => {
  enableNoSleep();
});

// 监听页面可见性变化
document.addEventListener("visibilitychange", () => {
  if (document.visibilityState === "visible") {
    enableNoSleep(); // 重新激活唤醒锁
  }
});

export async function switchEnv(params, configType) {
  if (isSupport()) {
    localStorage.setItem("envConfig", configType);
    await xda.switchEnv(params).catch((e) => {
      const error = WebError.error(e, defaultError.ILLEGAL_ARGUMENT);
      Toast(error.msg);
    });
  } else {
    const res = await personalCheck(params, getEnvConfig());

    if (res.success && res?.data?.intranet == 1) {
      res["data"].configType = configType;
      localStorage.setItem("envConfig", JSON.stringify(res["data"]));
    } else {
      Toast(res.message);
    }
  }
}

async function _getEnvConfig(envConfig) {
  const envStore = useEnvStore();
  if (isSupport()) {
    const _deviceInfo = await xda.deviceInfo();
    envConfig = _deviceInfo.config;
    console.log(JSON.stringify(envConfig));

    localStorage.setItem("deviceInfo", JSON.stringify(_deviceInfo));
    envStore.setDeviceInfo(_deviceInfo)
    envStore.setEnvConfig(envConfig)

    if (envConfig && envConfig.code === 10000) {
      envConfig = null;
    }
  } else {
    envConfig = JSON.parse(localStorage.getItem("envConfig"));
    console.log(JSON.stringify(envConfig));
  }

  try {
    if (envConfig) {
      const res = await personalCheck({code: envConfig.code}, envConfig);

      if (res.success && res.data.code === envConfig.code) {
        Object.assign(envConfig, res.data);
      }
    }
  } catch (e) {
    console.warn("personalCheck接口请求异常", e);
  }
  envStore.setEnvConfig(envConfig)
  return (envConfig);
}

export function getEnvConfig() {
  const envStore = useEnvStore();
  return envStore.envConfig;
}

export function getDeviceInfo() {
  const envStore = useEnvStore();
  return envStore.deviceInfo
}

export function getDeviceData() {
  const data = getDeviceInfo();
  // 判断是否有systemVersion属性
  if (data?.device?.systemVersion) {
    return data;
  }
  const type = getDeviceType();
  return {device: {type}};
}

export function getDeviceType() {
  const deviceInfo = getDeviceInfo();
  //移动端h5
  if (!deviceInfo) return 3;
  const type = deviceInfo?.type;
  //印控仪
  if (type == 3) {
    const device = deviceInfo?.device;
    return device?.is3568Device ? 2 : 1;
  }

  //app
  return 3;
}

// 是否鸿蒙系统
export function isOhos() {
  const deviceInfo = getDeviceInfo();
  return deviceInfo?.platform === 'ohos'
}

export function platformCode() {
  const deviceInfo = getDeviceInfo();
  let code = 1;
  if (deviceInfo?.platform === 'android') {
    code = 1;
  }else if (deviceInfo?.platform === 'iOS') {
    code = 2;
  }else if (deviceInfo?.platform === 'ohos') {
    code = 4;
  }
  return code
}

export function getCameraAngle(cameraType = 'back') {
  const deviceData = getDeviceData()
  let mirror = ''
  let quarterTurns = 0

  //一代印控仪
  if (deviceData.device.type == 1) {
    quarterTurns = cameraType == 'back' ? 3 : 0
  }

  //简易印控仪
  if (deviceData.device.type == 5) {
    quarterTurns = cameraType == 'back' ? 1 : 0
    mirror = 'x'
  } else if (deviceData.device.type == 1) {
    mirror = cameraType == 'back' ? 'y' : 'x'
  }

  //其余包括二代
  return {
    quarterTurns,
    mirror
  }
}

export async function initEnv() {
  let envConfig = await _getEnvConfig();
  if (envConfig) {
    service.defaults.baseURL = envConfig.personalAppUrl;
    request.defaults.baseURL = envConfig.personalAppUrl;
    if (envConfig.personalAppUrl.includes("apiv2.yda.cn")) {
      config.mqtt.url = `wss://iot.libawall.com/ws`;
    } else if (envConfig.personalMiniUrl) {
      config.mqtt.url = envConfig.personalMiniUrl;
    } else {
      const mqttUrl = (envConfig.personalAppUrl.replace("http", "ws"));
      config.mqtt.url = mqttUrl.endsWith("/") ? `${mqttUrl}ws` : `${mqttUrl}/ws`;
    }

    config.mqtt.mqttUrl = envConfig.personalIotUrl;

    console.log("config.mqtt", config.mqtt.url);
  } else {
    config.mqtt.url = process.env.VITE_API_MQTT_URL;
    config.mqtt.mqttUrl = process.env.VITE_API_MQTT_URL_FLUTTER;
    service.defaults.baseURL = process.env.VITE_API_BASE_URL;
    request.defaults.baseURL = process.env.VITE_API_BASE_URL;

    if (!config.mqtt.url.startsWith("ws")) {
      config.mqtt.url = (location.origin + config.mqtt.url).replace("http", "ws")
    }
  }

  //设置sdk请求头sourceType
  setHeader("sourceType", getSourceType())
}

export async function userLogout() {
  //停止后台上传
  uploadManager?.stopAllUpload();
  localStorage.removeItem("sessionId");
  localStorage.removeItem("mobile");
  localStorage.removeItem("userInfo");
  setSessionId();
  await Device.close();
  if (window.location.href.includes("businessType")) {
    localStorage.setItem("message_url", window.location.href);
  }
}

//获取地址栏
export const getLocation = (name) => {
  // 未传参，返回空
  if (!name) return null;
  // 查询参数：先通过search取值，如果取不到就通过hash来取
  var after = window.location.search;
  after = after.substr(1) || window.location.hash.split("?")[1];
  // 地址栏URL没有查询参数，返回空
  if (!after) return null;
  // 如果查询参数中没有"name"，返回空
  if (after.indexOf(name) === -1) return null;

  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  // 当地址栏参数存在中文时，需要解码，不然会乱码
  var r = decodeURI(after).match(reg);
  // 如果url中"name"没有值，返回空
  if (!r) return null;

  return r[2];
};

// 检查资源更新
export const updateH5Version = () => {
  const deviceStore = useDeviceStore();
  if (isSupport()) {
    service.local = true;
    let appLifecycleStatus = false;
    xda.onAppLifecycle(async (data) => {
      console.log("防息屏", noSleep.isEnabled);

      if (data.type === "paused") {
        appLifecycleStatus = true;
      } else if (data.type === "resumed" && appLifecycleStatus) {
        noSleep.enable().finally(() => {
          console.log("开启防息屏");
        });
        appLifecycleStatus = false;
        const deviceInfo = getDeviceInfo()
        var checkVersionFlag = await xda.checkVersion(2, deviceInfo?.device?.number);
        console.log(checkVersionFlag, "checkVersionFlag");
        console.log("设备是否处于连接", deviceStore.isConnect);
        if (checkVersionFlag && !deviceStore.isConnect) {
          Dialog.confirm({
            title: "提示",
            message: "当前存在未更新资源，是否确认更新",
          }).then(() => {
            xda.updateVersion(2, {
              number: deviceInfo?.device?.number,
              onProgress: (progress) => {
                console.log("updateVersion", JSON.stringify(progress));
              },
            });
          });
        }
      }
    });
  }
};
